import React from 'react';
import Popper from '@material-ui/core/Popper/Popper';

const PopperComponent = ({ open, anchorEl, style, disablePortal, placement, modifiers, children }) => {
  return (
    <Popper
      style={style}
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      disablePortal={disablePortal}
      modifiers={modifiers}
    >
        {children}
    </Popper>
  );
};

export default PopperComponent;
